module.exports = __webpack_public_path__ + "img/step1-c.d2c29bab.png";